import { useCallback, useRef, useState } from 'react';

export function useScheduleHeaderPopups() {
  // DateSelect
  const [dateSelectVisible, setDateSelectVisible] = useState(false);
  const [dateSelectPosition, setDateSelectPosition] = useState({ top: 0, left: 0 });
  const dateSelectBtnRef = useRef<HTMLButtonElement>(null);

  const openDateSelect = useCallback(() => {
    if (!dateSelectBtnRef.current) return;
    const rect = dateSelectBtnRef.current.getBoundingClientRect();
    setDateSelectPosition({
      top: rect.bottom + 6,
      left: rect.left,
    });
    setDateSelectVisible(true);
  }, []);

  const closeDateSelect = useCallback(() => setDateSelectVisible(false), []);

  // Schedule 版本切换 / 新建（ScheduleSearch 弹层）
  const [scheduleSearchVisible, setScheduleSearchVisible] = useState(false);
  const [scheduleSearchPosition, setScheduleSearchPosition] = useState({ top: 0, left: 0 });
  const addButtonRef = useRef<HTMLButtonElement>(null);

  const openScheduleSearch = useCallback(() => {
    if (!addButtonRef.current) return;
    const rect = addButtonRef.current.getBoundingClientRect();
    setScheduleSearchPosition({
      top: rect.bottom + 2,
      left: rect.left,
    });
    setScheduleSearchVisible(true);
  }, []);

  const closeScheduleSearch = useCallback(() => setScheduleSearchVisible(false), []);

  return {
    dateSelect: {
      visible: dateSelectVisible,
      position: dateSelectPosition,
      btnRef: dateSelectBtnRef,
      open: openDateSelect,
      close: closeDateSelect,
      setVisible: setDateSelectVisible,
      setPosition: setDateSelectPosition,
    },
    scheduleSearch: {
      visible: scheduleSearchVisible,
      position: scheduleSearchPosition,
      btnRef: addButtonRef,
      open: openScheduleSearch,
      close: closeScheduleSearch,
      setVisible: setScheduleSearchVisible,
      setPosition: setScheduleSearchPosition,
    },
  };
}
